import { createContext, useContext, useState, useCallback } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("relatemetrics_user") || localStorage.getItem("attune_user");
    return raw ? JSON.parse(raw) : null;
  });

  const login = useCallback((u) => {
    localStorage.setItem("relatemetrics_user", JSON.stringify(u));
    localStorage.removeItem("attune_user");
    setUser(u);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("relatemetrics_user");
    localStorage.removeItem("attune_user");
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
